/**
 * Every string `/pages/about` renders.
 *
 * **No body text lives here.** Every block on the page is operator-entered
 * content that arrives from `backend-content`; what this file carries is the
 * console's own wording — the headings, the labels, the hints, and the sentences
 * that tell an operator what a control does.
 */
export const copy = {
  crumb: 'من نحن',

  head: {
    title: 'من نحن',
    lede: 'جسم الصفحة العامّة «من نحن» كما يقرأه الزائر. ثلاثة أقسام يسمّيها الفهرس — وصف الخدمة، والرسالة، والتعريف بالمشغّل — ولا رابع.',
  },

  identity: {
    /** What the operator edits, said in what they can act on. */
    bodyShape: 'كتل نصّية — عنوان وفقرة وقائمة',
  },

  lede: {
    hint: 'جملة واحدة. تظهر قبل أن يقرأ الزائر شيئاً من الجسم.',
    note: 'الجملة الواحدة تحت عنوان الصفحة العامّة. تقع فوق الجسم ولا تدخل الكتل — الترويسة موضعٌ آخر في الصفحة المعروضة.',
  },

  body: {
    heading: 'جسم الصفحة',
    note: 'ثلاثة أنواع من الكتل، وهي ما ينسّقه العارض العامّ لجسم هذه الصفحة: عنوان، وفقرة، وقائمة. القائمة سطرٌ لكلّ عنصر. لا صورة ولا مقطع ولا اقتباس — تلك أنواع جسم المقال، ولا صفّ يعطيها لصفحة تعريفية.',
    inlineNote: 'التوكيد والروابط داخل النصّ تحملها الطبقة السطرية في محرّر الإنتاج، ولا تُحرَّر من هنا.',
    empty: 'لا كتل بعد. ابدأ بعنوان من الصندوق أدناه، ثمّ أضف تحته فقرةً أو قائمة.',
  },

  add: {
    label: 'أضف كتلة',
    title: 'أضف كتلة',
    hint: 'تُضاف في آخر الجسم، ثمّ تُنقل بمقابض الكتلة إلى موضعها.',
  },

  block: {
    moveUp: 'انقل الكتلة إلى الأعلى',
    moveDown: 'انقل الكتلة إلى الأسفل',
    remove: (label: string) => `احذف كتلة ${label}`,
  },

  announce: {
    added: (label: string) => `أُضيفت كتلة ${label} في آخر الجسم.`,
    moved: (label: string, position: string, total: string) =>
      `نُقلت كتلة ${label} إلى الموضع ${position} من ${total}.`,
    removed: (label: string, remaining: string) => `حُذفت كتلة ${label}. بقيت ${remaining} كتلة.`,
    atStart: 'الكتلة في أوّل الجسم.',
    atEnd: 'الكتلة في آخر الجسم.',
  },

  saved: {
    /**
     * The public page is still served through an ISR cache, but the owning
     * service now purges that cache entry as part of the write, so the lag an
     * operator used to measure at around three and a half minutes is gone. The
     * sentence says «on reload» rather than «instantly» because the reader has
     * to fetch the page again to see it — the cache is what was slow, not the
     * browser.
     */
    body: 'حُفظ النصّ، وصفحة «من نحن» العامّة تحمل الجديد فور تحديثها.',
  },

  /**
   * The one state this surface refuses to open in.
   *
   * A stored body carrying structure these three kinds cannot hold — an inline
   * link, a nested list, a tag the editor has no block for — would lose that
   * structure on the first save. The operator is told what is in the way and
   * what to do, and the editor stays closed rather than showing a body it would
   * quietly truncate.
   */
  unsupported: {
    title: 'هذا الجسم لا يُحرَّر من هنا',
    body: 'الصفحة تحمل نصّاً بترتيب لا تمثّله كتل هذا المحرّر، وفتحه هنا كان سيُسقط جزءاً منه عند أوّل حفظ. راجع الدعم قبل تعديل هذه الصفحة.',
  },
} as const;
